import { render } from "./UserGroupManage.vue?vue&type=template&id=38e0aa71&scoped=true"
import script from "./UserGroupManage.vue?vue&type=script&lang=js"
export * from "./UserGroupManage.vue?vue&type=script&lang=js"

import "./UserGroupManage.vue?vue&type=style&index=0&id=38e0aa71&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e0aa71"]])

export default __exports__